import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import App from './App';
import beforeSend from './Infrastructure/Sentry/beforeSend';

Sentry.init({
  dsn: __CONFIG__.sentry.dsn,
  enabled: __CONFIG__.sentry.enabled,
  environment: __CONFIG__.sentry.environment,
  release: `${__CONFIG__.sentry.projectName}@${__VERSION__ || ''}`,
  beforeSend,
});

const container = document.getElementById('root');
const root = container !== null ? createRoot(container) : null;
root?.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
